module.exports = __webpack_public_path__ + "static/media/543600C0-DB5B-49A6-AB05-0AF5224A10EA.881d8611.JPG";